import { render, staticRenderFns } from "./HomeSubList.vue?vue&type=template&id=08acc812&scoped=true&"
import script from "./HomeSubList.vue?vue&type=script&lang=js&"
export * from "./HomeSubList.vue?vue&type=script&lang=js&"
import style0 from "./HomeSubList.vue?vue&type=style&index=0&id=08acc812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08acc812",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
installComponents(component, {VBtn,VCard})
